import API, { newAPI } from '../api/api';
import { AuthenticationService } from './AuthenticationService';

/**
* API Interceptors
* ----------------
* Configures Axios interceptors for handling authentication and error responses.
*
* Request Interceptor:
* - Adds the JWT token from AuthenticationService to the Authorization header.
* - Adds the partner ID (from JWT) to the `partnerId` header.
* - Adds the distributor ID (from JWT) to the `distributorId` header.
*
* Response Interceptor:
* - Returns the response as-is if successful.
* - Automatically redirects to `/login` if a 401 Unauthorized error occurs.
**/

API.interceptors.request.use(
  (config) => {
    const token = AuthenticationService.getToken();
    const distributorId = AuthenticationService.getPropertyFromJtwToken("distributorId");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    if (distributorId) {
      config.headers['distributorId'] = distributorId;
    } 

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

API.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
); 

newAPI.interceptors.request.use(
  (config) => {
    const token = AuthenticationService.getTokenForNewAPI();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

newAPI.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      window.location.href = '/login';
    }
  }
);

export { newAPI };
export default API;
